import type { EventTag } from '@mortgage-pos/types'
import newRelic from '@mortgage-pos/ui/services/newRelic'

export type FileUploadFailureReason =
  | 'unsupported_file_type'
  | 'too_many_files'
  | 'upload_error'

type TrackFileUploadFailureArgs = {
  source: string
  reason: FileUploadFailureReason
  documentType?: string
  file?: File | null
  error?: unknown
  message?: string
}

function tag(key: string, value: unknown): EventTag | null {
  if (value === undefined || value === null || value === '') return null

  return {
    key,
    value: value instanceof Error ? value.message : String(value),
  }
}

function compactTags(tags: Array<EventTag | null>): EventTag[] {
  return tags.filter((item): item is EventTag => Boolean(item))
}

function errorMessage(error: unknown): string | undefined {
  if (!error) return undefined
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  return String(error)
}

export function trackFileUploadFailure({
  source,
  reason,
  documentType,
  file,
  error,
  message,
}: TrackFileUploadFailureArgs) {
  void newRelic.increment(
    'file_upload.failure',
    compactTags([
      tag('source', source),
      tag('reason', reason),
      tag('documentType', documentType),
      tag('fileName', file?.name),
      tag('fileType', file?.type),
      tag('fileSizeMb', file ? Math.round(file.size / 1024 / 1024) : undefined),
      tag('message', message),
      tag('error', errorMessage(error)),
    ])
  )
}
